import {
  CRM_LEAD_HIDDEN_STATUSES,
  CRM_LEAD_HIDEABLE_STATUSES,
  type CrmLeadStatus,
} from '@ip/shared-types';

/**
 * What the UI may offer on one lead. Pure (no React) so the queue row menu,
 * the bulk bar and the detail sheet cannot drift apart — they used to each
 * carry their own copy of the status lists, and the frontend has no test
 * runner to catch the day they stop agreeing.
 *
 * The status sets come from shared-types, so a new lead status is a
 * compile-time decision on the backend side rather than a silently missing
 * menu entry here.
 */
export interface LeadCapabilities {
  /** Active lead → can be hidden (rejected/spam) with a reason. */
  canHide: boolean;
  /** Hidden lead → can be brought back into the active queue. */
  canRestore: boolean;
  /** Hard delete: caller must be a company admin AND the lead not converted. */
  canDelete: boolean;
  /** False = the ⋮ menu would be empty, so it is not rendered at all. */
  hasActions: boolean;
}

export function leadCapabilities(status: CrmLeadStatus, canDelete: boolean): LeadCapabilities {
  const hide = CRM_LEAD_HIDEABLE_STATUSES.includes(status);
  const restore = CRM_LEAD_HIDDEN_STATUSES.includes(status);
  // A converted lead is the origin record of an account/deal — it is never
  // deletable, whatever the caller's role (the backend enforces the same).
  const remove = canDelete && status !== 'converted';
  return {
    canHide: hide,
    canRestore: restore,
    canDelete: remove,
    hasActions: hide || restore || remove,
  };
}
